var map = {
	"./slogan1_black.png": "FejH",
	"./slogan2_black.png": "5FAS",
	"./slogan3_black.png": "m7jc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AlxX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slogan ^\.\/slogan.*_black\.png$
// module id = AlxX
// module chunks = 0